/**
 * PilotBottomMask component.
 */
import Mask from '@shared/assets/images/png/pilotBottomMask.png';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withImage from '@shared/components/utils/hoc/withImage';

/**
 * Styled pilot bottom mask.
 */
const PilotBottomMask = styled.img<React.CSSProperties>`
  bottom: 0;
  height: ${387 * Screen.widthRatio}px;
  opacity: ${(props) => props.opacity || 1};
  overflow: hidden;
  position: absolute;
  width: 100%;
  z-index: 1;
`;

PilotBottomMask.defaultProps = {
  src: Mask,
};

export default withImage(PilotBottomMask, false);
